import { HStack } from "@chakra-ui/react";
import { VerticalGroup } from "../VerticalGroup/VerticalGroup";
import { ToggleButton } from "../ToggleButton/ToggleButton";
import { GenderPreference } from "@greenflagdate/shared";

interface GenderPreferenceProps {
  value?: string;
  onChange: (value?: GenderPreference) => void;
  appearance?: "vertical" | "horizontal";
  /** Greys out the options — used when the viewer has chosen friends only. */
  disabled?: boolean;
}

export const GenderPreferenceSelector = ({
  value,
  onChange,
  appearance,
  disabled,
}: GenderPreferenceProps) => {
  appearance = appearance || "vertical";
  const WrapperComponent = appearance === "horizontal" ? HStack : VerticalGroup;

  return (
    <WrapperComponent width="100%" opacity={disabled ? 0.45 : 1}>
      <ToggleButton
        width="100%"
        disabled={disabled}
        onClick={() => onChange("man")}
        isActive={value?.toLowerCase() === "man"}
      >
        Men
      </ToggleButton>
      <ToggleButton
        width="100%"
        disabled={disabled}
        onClick={() => onChange("woman")}
        isActive={value?.toLowerCase() === "woman"}
      >
        Women
      </ToggleButton>
      <ToggleButton
        width="100%"
        disabled={disabled}
        onClick={() => onChange("everyone")}
        isActive={value?.toLowerCase() === "everyone"}
      >
        Everyone
      </ToggleButton>
    </WrapperComponent>
  );
};
